export class Step {
  stepNumber : number ;
  completed : boolean = false;
}
